// «Расходы» на дашборде: итог за год → Безнал / Наличные → группы (по management.expense_rows)
export type ExpenseRows = Record<string, { bank?: number; cash?: number } | undefined>;
export type ExpenseGroup = { key: string; label: string; amount: number; target?: string; title?: string };
export type ExpenseSide = { total: number; groups: ExpenseGroup[] };

const GROUPS: { key: string; label: string; keys: string[]; target?: string; title?: string }[] = [
  { key: 'people', label: 'Выплаты людям', keys: ['salary_official', 'salary_unofficial', 'self_employed'], target: 'dash-people',
    title: 'Зарплата штату на руки, неофициальные выплаты и самозанятые — подробно в блоке «Выплаты людям»' },
  { key: 'purchases', label: 'Расходы и покупки', keys: ['purchases'], title: 'Оплаты контрагентам и покупки' },
  { key: 'taxes', label: 'Налоги и взносы', keys: ['taxes'], target: 'dash-taxes',
    title: 'Перечислено на ЕНС и в СФР — подробно в блоке «Налоги и ЕНС»' },
  { key: 'withdrawals', label: 'Вывод себе', keys: ['withdrawals'] },
  { key: 'dividends', label: 'Дивиденды', keys: ['dividends'] },
];

const round2 = (n: number) => Math.round(n * 100) / 100;

export function expenseBreakdown(rows: ExpenseRows | undefined, withDividends = true) {
  const side = (m: 'bank' | 'cash'): ExpenseSide => {
    const groups = GROUPS.filter(g => withDividends || g.key !== 'dividends')
      .map(g => ({ key: g.key, label: g.label, target: g.target, title: g.title,
                   amount: round2(g.keys.reduce((s, k) => s + (rows?.[k]?.[m] || 0), 0)) }));
    return { total: round2(groups.reduce((s, g) => s + g.amount, 0)), groups: groups.filter(g => Math.abs(g.amount) >= 0.005) };
  };
  const bank = side('bank'), cash = side('cash');
  return { total: round2(bank.total + cash.total), bank, cash };
}
